(() => {
  const rootSelector = '.related-product-section__recommendations';
  const sliderSelector = '[data-related-product-slider]';

  const destroySlider = (slider) => {
    if (slider?.relatedProductsSplide) {
      slider.relatedProductsSplide.destroy(true);
      slider.relatedProductsSplide = null;
    }
  };

  const mountSlider = (root) => {
    const slider = root.querySelector(sliderSelector);
    if (!slider || typeof window.Splide === 'undefined') return;
    const slideCount = slider.querySelectorAll('.splide__slide').length;
    if (!slideCount || slider.relatedProductsSplide) return;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    slider.relatedProductsSplide = new window.Splide(slider, {
      type: slideCount > 1 ? 'loop' : 'slide',
      fixedWidth: 'clamp(28rem, 28.125vw, 54rem)',
      gap: 'clamp(1.6rem, 1.45vw, 2.8rem)',
      focus: 'center', trimSpace: false, perMove: 1, arrows: false, pagination: false,
      drag: slideCount > 1, keyboard: 'global', lazyLoad: 'nearby',
      speed: Number(slider.dataset.speed) || 700,
      autoplay: slider.dataset.autoplay === 'true' && !reduceMotion && slideCount > 1,
      interval: Number(slider.dataset.interval) || 5000,
      pauseOnHover: slider.dataset.pauseOnHover !== 'false', pauseOnFocus: true,
      breakpoints: { 989: { fixedWidth: '44vw' }, 749: { fixedWidth: '82vw', gap: '1.4rem' } }
    }).mount();
  };

  const initialize = (root) => {
    if (!root || root.relatedProductsObserver) return;
    mountSlider(root);
    root.relatedProductsObserver = new MutationObserver(() => window.requestAnimationFrame(() => mountSlider(root)));
    root.relatedProductsObserver.observe(root, { childList: true });
  };

  const initializeAll = (scope = document) => scope.querySelectorAll(rootSelector).forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll());
  else initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => event.target.querySelectorAll(rootSelector).forEach((root) => {
    destroySlider(root.querySelector(sliderSelector));
    root.relatedProductsObserver?.disconnect();
  }));
})();
